module.exports = __webpack_public_path__ + "static/media/image-2.b74a6dae.png";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/Blog/FacebookBusiness/image-2.png
// module id = 430
// module chunks = 0